(function () {
  'use strict';

  const MAX_ENTRIES = 100;
  const entries = [];

  function getFramework() {
    return window.UnifiedTracking || null;
  }

  function isDebugEnabled() {
    const framework = getFramework();

    return Boolean(
      framework &&
      framework.config &&
      framework.config.debug
    );
  }

  function formatTime(timestamp) {
    const date = new Date(timestamp);

    return date.toLocaleTimeString('ro-RO', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      fractionalSecondDigits: 3
    });
  }

  function getSummary(entry) {
    const data = entry.data || {};
    const details = data.details || {};

    if (details.event) {
      return details.event;
    }

    if (data.event) {
      return data.event;
    }

    if (data.message) {
      return data.message;
    }

    return entry.type;
  }

  function addEntry(detail) {
    const entry = {
      id: entries.length + 1,
      type: detail.type || 'unknown',
      timestamp: detail.timestamp || new Date().toISOString(),
      data: detail.data || {}
    };

    entries.push(entry);

    if (entries.length > MAX_ENTRIES) {
      entries.shift();
    }

    if (isDebugEnabled()) {
      renderConsoleEntry(entry);
    }

    return entry;
  }

  function renderConsoleEntry(entry) {
    const summary = getSummary(entry);

    console.groupCollapsed(
      '%c[Unified Debug]%c ' +
        formatTime(entry.timestamp) +
        ' · ' +
        entry.type +
        ' · ' +
        summary,
      'color:#7D664B;font-weight:bold;',
      'color:inherit;font-weight:normal;'
    );

    console.log('Type:', entry.type);
    console.log('Timestamp:', entry.timestamp);
    console.log('Data:', entry.data);

    console.groupEnd();
  }

  function printHistory() {
    if (!entries.length) {
      console.info('[Unified Debug] No entries recorded.');

      return [];
    }

    console.table(
      entries.map(function (entry) {
        return {
          id: entry.id,
          time: formatTime(entry.timestamp),
          type: entry.type,
          summary: getSummary(entry)
        };
      })
    );

    return entries.slice();
  }

  function getHistory() {
    return entries.slice();
  }

  function clearHistory() {
    entries.length = 0;

    console.info('[Unified Debug] History cleared.');
  }

  function findByType(type) {
    return entries.filter(function (entry) {
      return entry.type === type;
    });
  }

  function findByEvent(eventName) {
    return entries.filter(function (entry) {
      const data = entry.data || {};
      const details = data.details || {};

      return (
        data.event === eventName ||
        details.event === eventName
      );
    });
  }

  function handleDebugEvent(event) {
    if (!event.detail) {
      return;
    }

    addEntry(event.detail);
  }

  window.addEventListener(
    'unified:debug',
    handleDebugEvent
  );

  window.UnifiedDebug = {
    version: '1.0.0',

    getHistory: getHistory,

    printHistory: printHistory,

    clearHistory: clearHistory,

    findByType: findByType,

    findByEvent: findByEvent
  };

  if (isDebugEnabled()) {
    console.info('[Unified Debug] Console initialized');
  }
})();